const list = async () => { return []; };

export const ReferenceService = {
    list,
};